<script setup>
import backgroundImage from '@/assets/home/background.jpg'

defineProps({

  destination: {
    type: Object,
    required: true
  }
});

</script>



<template>
  <div
      class="landingImage"
      :style="{
      backgroundImage: `linear-gradient(to bottom, rgba(16, 10, 53, 0.7), rgba(16, 10, 53, 0)), url(${destination?.image})`
    }"
  >
    <div class="container hero-container items-center flex flex-col h-full justify-center">
      <div class="responsive-title-1 font-thin mb-6 ml-3 text-center">
        {{ destination?.generalLocation }}
      </div>
    </div>
  </div>
</template>



<style scoped>
.landingImage {
  background-size: cover;
  object-fit: contain;
  background-attachment: fixed;

  height: 60vh;
  max-height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}

@media (max-width: 768px) {
  .landingImage {
    max-height: 474px;
    background-position: center;
  }
}
</style>

